// @flow

import { capitalize, escape, flow, startCase } from 'lodash';

import { singular } from '@zapier/common-utils';

import { NEW_SERVICE_FIELD } from 'app/developer-v3/constants';

const createChangelogString = ({
  reasons,
  description,
}: {
  reasons: { [key: string]: boolean },
  description: string,
}): string =>
  Object.keys(reasons)
    .filter((key: string) => reasons[key])
    .map(startCase)
    .concat(description)
    .join(', ');

/**
 * Escapes the provided string
 *
 * @param {string} value
 */
const makeTextHtmlSafe = (value: string): string => escape(String(value));

const getSettingsSaveText = (key: string) =>
  key === NEW_SERVICE_FIELD ? 'Save and Continue' : 'Save';

/**
 * Escapes the given string and for every line break, adds a br tag
 *
 * @param {string} value
 */
const convertPlainTextToHtml = (value: string): string =>
  makeTextHtmlSafe(value).split('\n').join('<br />');

const titleize = flow(singular, capitalize);

export {
  createChangelogString,
  convertPlainTextToHtml,
  getSettingsSaveText,
  makeTextHtmlSafe,
  titleize,
};
